import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import { DateType } from './Types';

class ReceivableApi {
    static getInitialData(): Promise<any> {
        return new Api().get(`/views/receivable`);
    }

    static getData(
        legalEntityId: number,
        fromDate: any,
        toDate: any,
        onlyUnsettledInvoices: boolean,
        customer: number
    ): Promise<any> {
        return new Api().post(`/views/receivable`, {
            legalEntityId: legalEntityId,
            fromDate: fromDate,
            toDate: toDate,
            onlyUnsettledInvoices: onlyUnsettledInvoices,
            customer: customer
        });
    }
}

export default ReceivableApi;
